import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import { addQuestion } from '../../services/feedbackService';
import QuestionForm from './QuestionForm';

function QuestionAdd(props) {
  const initialValues = {
    type: '',
    question: '',
    options: [],
    tag: false,
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  const onSubmit = async (values) => {
    let payload = {
      ...values,
      tag: values.tag ? 'overallRating' : null,
    };

    setStatus({ type: 'LOADING', message: 'Request in Progress!' });
    await addQuestion(payload)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({ type: 'SUCCESS', message: 'Data added successfully!' });
      })
      .catch((error) => {
        alert('Getting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Add New Question`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={'*NOTE: Questions added cannot be edited and deleted'}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <QuestionForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
        />
      )}
    </Modal>
  );
}

export default QuestionAdd;
